/**
 * takeInterruption — 방금 온 이벤트가 **이 테이크를 무효로 만드나**.
 *
 * 네이티브는 오디오 세션이 끊기면 알리고, 끝나면 스스로 세션을 되살려 프레임을 다시
 * 보낸다(`MuzlyPitchTracker` 의 interruption ended 에서 `[_capture recover]`, Android 는
 * 포커스 복귀에서, 반주 세션이면 오디오 모드가 통화에서 돌아올 때 `recoverCapture()`). 프레임이 이어지므로 화면은 아무 일도 없던 것처럼
 * 계속되지만, **노래 진단만은 그래서는 안 된다**: 채점의 시간 앵커가 반주 재생을 시작한
 * 시각이고(`SongReferenceAudio`) 반주는 끊긴 동안 흘러가 버렸다. 이어 부른 프레임은
 * 엉뚱한 음에 대응되고, 사용자는 제대로 불렀는데 틀렸다는 점수를 받는다.
 *
 * 그래서 노래 테이크는 끊긴 순간 버린다 — 화면이 그것을 말하고 처음부터 다시 가게 한다.
 * 반주가 없는 진단(지속·저음·고음)은 시간 앵커가 없어 이어서 불러도 값이 그대로다.
 *
 * **`stream_discontinuity` 는 사유가 아니다.** 그것은 read 루프가 프레임 하나를 놓칠
 * 때마다 오르는 값이라(`MuzlyAudioCapture` 의 dropout 계수) 흔하고, 그것마다 테이크를
 * 버리면 노래 진단을 끝까지 부를 수 없다. 반주를 실제로 밀어내는 것은 세션이 죽었다
 * 살아난 인터럽션이다.
 */
export const takeInterruption = (
  /** 이 테이크에 반주가 같이 나가나 — `StartOptions.backingTrack`. */
  backingTrack: boolean,
  /** 방금 온 이벤트 이름(`PitchTrackerEvent['type']`). */
  eventType: string,
): boolean => backingTrack && eventType === 'interruption_started';
